import {
  PageHeader,
  Tag,
  Radio,
  Table,
  Tooltip,
  Select,
  Row,
  Col,
  DatePicker,
  Empty,
  Space,
  Input,
  Form,
} from "antd";
import React, { Component } from "react";
import {
  MailOutlined,
  CalendarOutlined,
  AppstoreOutlined,
  BarsOutlined,
  SearchOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { connect } from "react-redux";
import { dineroDisabledMask } from "../../../Components/Items";
import {
  SelectItem,
  TableItemDinamico,
  FormItem,
} from "../../../Components/Items";
import ButtonItem from "../../../Components/ButtonItem";
import axios from "axios";
import moment from "moment";

const { RangePicker } = DatePicker;
const { Option } = Select;

class HistorialCorreos extends Component {
  state = {
    loading: false,
    registros: [],
    totalRecords: 0,
    modoVista: 1, // 1 : Agrupados (General)  0 : Listado (Individual)
    activeFilters: {
      createdAt: {
        $gte: moment().startOf("month").startOf("day").toISOString(),
        $lte: moment().endOf("day").toISOString(),
      },
    },
    usuarios: [],
    tiposCorreo: [],
  };

  componentDidMount() {
    this.consultarUsuarios();
    this.consultarTiposCorreo();
  }

  consultarUsuarios = async () => {
    await axios
      .post(
        "/usuarios/selectUsuariosEmpresa",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data) {
          this.setState({
            usuarios: res.data.map((u) => (
              <Option key={u._id} value={u._id}>
                {`${u.nombre} ${u.apellidoPaterno || ""}`}
              </Option>
            )),
          });
        }
      });
  };

  consultarHistorial = async (params = {}) => {
    this.setState({ loading: true });

    const { modoVista } = this.state;

    const filtrosCombinados = {
      ...params.filters,
      ...this.state.activeFilters,
    };

    const body = {
      empresaId: this.props.empresaId,
      page: params.page || 1,
      pageSize: params.pageSize || 20,
      sortField: params.sortField || "createdAt",
      sortOrder: params.sortOrder || "descend",
      filters: filtrosCombinados || {},
    };

    const url =
      modoVista === 1
        ? "/correosEnviadosGeneral/selectHistorialCorreosGeneral"
        : "/correoEnviado/selectHistorialCorreosIndividual";

    axios
      .post(url, body, {
        headers: this.props.headersToken,
      })
      .then((res) => {
        if (res.data.success === 2 || res.data.success === true) {
          this.setState({
            registros: res.data.data,
            totalRecords: res.data.totalRecords,
            loading: false,
          });
        } else {
          this.setState({ registros: [], totalRecords: 0, loading: false });
        }
      })
      .catch((error) => {
        console.error("Error al consultar historial", error);
        this.setState({ loading: false, registros: [] });
      });
  };

  consultarTiposCorreo = async () => {
    try {
      const res = await axios.post(
        "/correoEnviado/obtenerTiposCorreoDisponibles", 
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      );

      if (res.data.success === 2 && res.data.data) {
        this.setState({ tiposCorreo: res.data.data });
      }
    } catch (error) {
      console.error("Error cargando tipos de correo", error);
    }
  };

  // Columnas para las tablas internas
  getColumnasDetalle = () => {
    return [
      {
        title: "Hora",
        dataIndex: "createdAt",
        key: "hora",
        width: "10%",
        render: (text) => (
          <span style={{ color: "#666" }}>{moment(text).format("HH:mm")}</span>
        ),
      },
      {
        // `nombreCliente` guarda el nombre del destinatario sea quien sea: los
        // recibos de nómina caen aquí con el nombre del empleado.
        title: "Cliente - Proveedor - Empleado / Correo",
        dataIndex: "nombreCliente",
        key: "nombreCliente",
        width: "35%",
        render: (text, record) => (
          <div>
            <span>{text}</span>
            <br />
            <span style={{ fontSize: "11px", color: "#888" }}>
              {record.correoDestinatario}
            </span>
          </div>
        ),
      },
      {
        title: "Tipo",
        dataIndex: "tipoCorreo",
        key: "tipoCorreo",
         width: "15%",
        render: (text) => <Tag color="blue">{text}</Tag>,
      },
      {
        title: "Monto",
        dataIndex: "cobro",
        key: "cobro",
        align: "right",
        width: "20%",
        render: (monto) => dineroDisabledMask(monto),
      },
      {
        title: "Estado",
        dataIndex: "estado",
        key: "estado",
        align: "center",
        width: "20%",
        render: (estado, record) => {
          if (estado === 1) {
            return (
              <Tag color="success" icon={<CheckCircleOutlined />}>
                Enviado
              </Tag>
            );
          }
          return (
            <Tooltip title={record.motivoNoEnvio}>
              <Tag color="error" icon={<CloseCircleOutlined />}>
                Error
              </Tag>
            </Tooltip>
          );
        },
      },
    ];
  };

  // Columnas para Modo Agrupado (CorreosEnviadosGeneral)
  getColumnasAgrupadas = () => {
    return [
      {
        title: "Fecha",
        dataIndex: "createdAt",
        key: "createdAt",
        width: "12%",
        render: (text) => (
          <>
            <CalendarOutlined style={{ color: "#1890ff", marginRight: 8 }} />
            <span style={{ fontSize: 15, fontWeight: 400 }}>
              {moment(text).format("DD/MM/YYYY")}
            </span>
          </>
        ),
      },
      {
        title: "Tipo de Envío",
        dataIndex: "tipoEnvio", // "Manual", "Automático"
        key: "tipoEnvio",
        width: "14%",
        render: (text, record) => (
          <Tag color={text === "Automático" ? "purple" : "cyan"}>{text}</Tag>
        ),
      },
      {
        title: "Tipo de Correo",
        dataIndex: "tipoCorreo",
        key: "tipoCorreo",
        width: "18%",
        render: (text, record) => <span>{record.tipoCorreo}</span>,
      },
      {
        title: "Usuario",
        dataIndex: "usuarioId",
        key: "usuarioId",
        width: "22%",
        render: (user) =>
          user ? (
            <span>
              <UserOutlined /> {user.nombre} {user.apellidoPaterno}{" "}
              {user.apellidoMaterno}
            </span>
          ) : (
            <span style={{ fontStyle: "italic" }}>Sistema</span>
          ),
      },
      {
        title: "Resumen",
        key: "resumen",
        width: "14%",
        render: (_, record) => (
          <Space>
            <Tooltip title="Correos Enviados Exitosamente">
              <Tag color="success" icon={<CheckCircleOutlined />}>
                {record.cantidadEnviados}
              </Tag>
            </Tooltip>
            {record.cantidadNoEnviados > 0 && (
              <Tooltip title="Correos Fallidos">
                <Tag color="error" icon={<CloseCircleOutlined />}>
                  {record.cantidadNoEnviados}
                </Tag>
              </Tooltip>
            )}
          </Space>
        ),
      },
      {
        title: "Monto Total",
        dataIndex: "cobroTotal",
        key: "cobroTotal",
        align: "right",
        width: "20%",
        render: (val) => dineroDisabledMask(val),
      },
    ];
  };

  // Columnas para Modo Listado (CorreoEnviado plano)
  getColumnasListado = () => [
  {
    title: "Fecha",
    dataIndex: "createdAt",
    key: "createdAt",
    width: "12%",
    render: (text) => moment(text).format("DD/MM/YYYY"),
  },
  ...this.getColumnasDetalle().map(col => ({
    ...col,
    width:
      col.key === "hora" ? "8%" :
      col.key === "nombreCliente" ? "30%" :
      col.key === "tipoCorreo" ? "14%" :
      col.key === "cobro" ? "18%" :
      "18%"
  })),
  {
    title: "Usuario",
    dataIndex: "usuarioId",
    key: "usuarioId",
    width: "20%",
    render: (user) =>
      user
        ? `${user.nombre} ${user.apellidoPaterno} ${user.apellidoMaterno}`
        : "Sistema",
  },
];

  // Render para expandir fila en modo Agrupado
  expandedRowRender = (record) => {
    const datosHijos = [
      ...(record.correosEnviados || []),
      ...(record.correosNoEnviados || []),
    ];

    datosHijos.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));

    return (
      <div style={{ margin: 0, padding: "10px 20px", background: "#fafafa" }}>
        <p style={{ marginBottom: 5, fontWeight: "bold", fontSize: 12 }}>
          Detalle de Correos de este grupo:
        </p>
        <Table
          columns={this.getColumnasDetalle()}
          dataSource={datosHijos}
          pagination={false}
          size="small"
          rowKey="_id"
          bordered
        />
      </div>
    );
  };

  handleChangeModoVista = (e) => {
    this.setState({ modoVista: e.target.value, registros: [] }, () => {
      this.consultarHistorial({ page: 1 });
    });
  };

  onFinishFilters = (values) => {
    const filtros = {};

    // Fecha
    if (values.periodo && values.periodo.length === 2) {
      filtros.createdAt = {
        $gte: values.periodo[0].startOf("day").toISOString(),
        $lte: values.periodo[1].endOf("day").toISOString(),
      };
    }

    // Usuario
    if (values.usuarios && values.usuarios.length > 0) {
      filtros.usuarioId = { $in: values.usuarios };
    }

    // Tipo de Correo
    if (values.tipoCorreo) {
      filtros.tipoCorreo = values.tipoCorreo;
    }

    if (values.estado !== undefined) {
      filtros.estado = values.estado;
    }

    // Búsqueda por texto (Correo o Cliente)
    if (values.busqueda) {
      filtros.$or = [
        { correoDestinatario: { $regex: values.busqueda, $options: "i" } },
        { nombreCliente: { $regex: values.busqueda, $options: "i" } },
      ];
    }

    this.setState({ activeFilters: filtros }, () => {
      this.consultarHistorial({ page: 1 });
    });
  };

  render() {
    const { modoVista, loading, totalRecords, registros } = this.state;

    return (
      <>
        <PageHeader
          title={
            <span>
              <MailOutlined /> Historial de Correos
            </span>
          }
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={[
            <div
              key="stats"
              style={{ display: "flex", gap: 20, marginRight: 20 }}
            >
              {/* Aquí podrías poner estadísticas rápidas si quisieras */}
            </div>,
          ]}
        />

        <div
          style={{
            backgroundColor: "white",
            padding: "15px 20px",
            border: "1px solid rgb(235, 237, 240)",
            marginBottom: 10,
            borderRadius: 4,
          }}
        >
          <Form
            layout="vertical"
            onFinish={this.onFinishFilters}
            initialValues={{
              periodo: [moment().startOf("month"), moment()],
              modoVista: 1,
            }}
          >
            <Row gutter={16} align="bottom">
              {/* Rango Fechas */}
              <Col xs={24} sm={12} md={6}>
                <FormItem
                  label="Fecha"
                  name="periodo"
                  style={{ marginBottom: 0 }}
                >
                  <RangePicker format="DD/MM/YYYY" style={{ width: "100%" }} />
                </FormItem>
              </Col>

              {/* Usuarios */}
              <Col xs={24} sm={15} md={9}>
                <FormItem
                  label="Usuario"
                  name="usuarios"
                  style={{ marginBottom: 0 }}
                >
                  <SelectItem
                    mode="multiple"
                    placeholder="Todos"
                    style={{ width: "100%" }}
                    allowClear
                    maxTagCount="responsive"
                  >
                    {this.state.usuarios}
                  </SelectItem>
                </FormItem>
              </Col>

              {/* Tipo Correo */}
              <Col xs={24} sm={9} md={6}>
                <FormItem
                  label="Tipo"
                  name="tipoCorreo"
                  style={{ marginBottom: 0 }}
                >
                  <Select allowClear placeholder="Todos">
                    {this.state.tiposCorreo.map((t) => (
                      <Option key={t} value={t}>
                        {t}
                      </Option>
                    ))}
                  </Select>
                </FormItem>
              </Col>

              {/* Botón Consultar */}
              <Col xs={24} md={3}>
                <FormItem style={{ marginBottom: 0 }}>
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    icon={<SearchOutlined />}
                    block
                  >
                    Filtrar
                  </ButtonItem>
                </FormItem>
              </Col>
            </Row>

            <Row gutter={16} style={{ marginTop: 15 }} align="middle">
              <Col>
                <FormItem label="Vista" style={{ marginBottom: 0 }}>
                  <Radio.Group
                    value={modoVista}
                    onChange={this.handleChangeModoVista}
                    buttonStyle="solid"
                  >
                    <Radio.Button value={1}>
                      <AppstoreOutlined /> Agrupado{" "}
                    </Radio.Button>
                    <Radio.Button value={0}>
                      <BarsOutlined /> Listado (Individual)
                    </Radio.Button>
                  </Radio.Group>
                </FormItem>
              </Col>

              <Col>
                <FormItem
                  name="estado"
                  label="Estado"
                  style={{ marginBottom: 0, width: 150 }}
                >
                  <Select
                    placeholder="Todos"
                    allowClear
                    disabled={this.state.modoVista === 1}
                  >
                    <Option value={1}>Enviados</Option>
                    <Option value={0}>Fallidos</Option>
                  </Select>
                </FormItem>
              </Col>

              {/* Búsqueda Texto*/}
              <Col xs={24} sm={12} md={4}>
                <FormItem
                  label="Cliente / Email"
                  name="busqueda"
                  style={{ marginBottom: 0 }}
                >
                  <Input
                    prefix={<SearchOutlined />}
                    placeholder="Buscar..."
                    allowClear
                    disabled={this.state.modoVista === 1}
                  />
                </FormItem>
              </Col>
            </Row>
          </Form>
        </div>

        <TableItemDinamico
          ref={(ref) => (this.tableRef = ref)}
          totalRecords={totalRecords}
          loading={loading}
          dataSource={registros}
          columns={
            modoVista === 1
              ? this.getColumnasAgrupadas()
              : this.getColumnasListado()
          }
          onFetchData={this.consultarHistorial}
          size="small"
          rowKey="_id"
          locale={{
            emptyText: <Empty description="No se encontraron correos" />,
          }}
          expandable={
            modoVista === 1
              ? {
                  expandedRowRender: this.expandedRowRender,
                  rowExpandable: (record) =>
                    record.cantidadEnviados + record.cantidadNoEnviados > 0,
                }
              : undefined
          }
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps, {})(HistorialCorreos);
